module.exports = __webpack_public_path__ + "img/iconeCadeado.960f2991.png";